import React from 'react'
import ListHeader from '../components/moduleComponents/ListHeader'
import ListSection from '../components/moduleComponents/ListSection'

const QuestionList = () => {
  return (
    <>
      <ListHeader />
      <ListSection />
    </>
  )
}

export default QuestionList
